import menuOverlays from "./menuOverlays"
import menuSelect from "./menuSelect"
import smoothScrolling from "./smoothScroll"

export default function modulesJS() {
    smoothScrolling()
    menuOverlays()
    menuSelect()
}